<template>
  <div>
    <div ref="dataTableCompleted"></div>
    <v-card flat class="rounded-xl pt-2 pb-4">
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('completedOrders.searchLabel')"
              single-line
              clearable
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-select
            v-model="paymentMethod"
            :items="methods"
            :label="$t('completedOrders.paymentMethodLabel')"
            clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-menu
              v-model="menuDateFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  :label="$t('completedOrders.dateFromLabel')"
                  persistent-hint
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateFrom"
                no-title
                @input="menuDateFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-menu
              v-model="menuDateTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  :label="$t('completedOrders.dateToLabel')"
                  persistent-hint
                  clearable
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateTo"
                no-title
                @input="menuDateTo = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        @update:page="$vuetify.goTo($refs.dataTable)"
        @update:sort-by="sortBy"
        @update:sort-desc="sortDesc"
        :headers="headers"
        :items="orders"
        :items-per-page="itemsPerPage"
        :loading="loading"
        :page="page"
        @click:row="details"
        @pagination="pagination"
        :server-items-length="totalItems"
        hide-default-footer
        :multi-sort="false"
        :must-sort="true"
        >
        <template v-slot:item.ordinalNumber="{ item, index }">
          {{ index+1 }}.
        </template>
        <template v-slot:item.created="{ item }">
          {{ item.created | dateFormat('YYYY-MM-DD') }}
        </template>
        <template v-slot:item.totalChargeAmount="{ item }">
          <div v-if="item.totalChargeAmount">{{ item.totalChargeAmount.toFixed(2) }} {{ getLocalCurrency }}</div>
        </template>
        <template v-slot:footer v-if="pageCount > 1">
          <v-pagination v-model="page" @input="handlePageChange" class="mt-4" :length="pageCount" :total-visible="7" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import Service from '@/services'
import _ from 'lodash'
export default {
  name: 'CashierCompleted',
  data () {
    return {
      loading: false,
      methods: [
        { text: this.$t('paymentMethods.onlinePayment'), value: 1 },
        { text: this.$t('paymentMethods.traditionalTransfer'), value: 2 },
        { text: this.$t('paymentMethods.points'), value: 3 }
      ],
      orders: [],
      search: '',
      dateFrom: null,
      dateTo: null,
      type: null,
      shoppingCenterId: null,
      menuDateFrom: false,
      menuDateTo: false,
      paymentMethod: null,
      page: 1,
      itemsPerPage: 50,
      totalItems: null,
      headers: [
        {
          text: 'Lp.',
          align: 'start',
          sortable: false,
          value: 'ordinalNumber'
        },
        {
          text: this.$t('completedOrders.date'),
          align: 'start',
          sortable: false,
          value: 'created'
        },
        { text: this.$t('completedOrders.orderNumber'), sortable: false, value: 'businessId' },
        {
          text: this.$t('completedOrders.status'),
          sortable: false,
          value: 'state'
        },
        {
          text: this.$t('completedOrders.paymentMethodLabel'),
          sortable: false,
          value: 'paymentMethod'
        },
        { text: this.$t('completedOrders.total'), sortable: false, value: 'totalChargeAmount' }
      ]
    }
  },
  async created () {
    if (this.$route.query.page) this.page = +this.$route.query.page
    if (this.$route.query.type) this.type = +this.$route.query.type
    if (this.$route.query.paymentMethod) this.paymentMethod = +this.$route.query.paymentMethod
    if (this.$route.query.shoppingCenterId) this.shoppingCenterId = +this.$route.query.shoppingCenterId
    if (this.$route.query.dateFrom) this.dateFrom = this.$route.query.dateFrom
    if (this.$route.query.dateTo) this.dateTo = this.$route.query.dateTo

    await this.getOrders()
    this.debouncedGetOrders = _.debounce(this.getOrders, 500)
  },
  computed: {
    pageCount () {
      try {
        return Math.ceil(this.totalItems / this.itemsPerPage)
      } catch {
        return 1
      }
    },
    getLocalCurrency () {
      return localStorage.getItem('currency')
    }
  },
  watch: {
    search () {
      this.page = 1
      this.debouncedGetOrders()
    },
    type () {
      this.page = 1
      this.getOrders()
    },
    paymentMethod () {
      this.page = 1
      this.getOrders()
    },
    shoppingCenterId () {
      this.page = 1
      this.getOrders()
    },
    dateFrom () {
      this.page = 1
      this.getOrders()
    },
    dateTo () {
      this.page = 1
      this.getOrders()
    }
  },
  methods: {
    async getOrders () {
      this.loading = true

      let url = `?page=${this.page}&size=${this.itemsPerPage}`

      if (this.state) {
        url += `&state=${this.state}`
      }
      if (this.type) {
        url += `&type=${this.type}`
      }
      if (this.paymentMethod) {
        url += `&paymentMethod=${this.paymentMethod}`
      }
      if (this.shoppingCenterId) {
        url += `&shoppingCenterId=${this.shoppingCenterId}`
      }
      if (this.dateFrom) {
        url += `&dateFrom=${this.dateFrom}`
      }
      if (this.dateTo) {
        url += `&dateTo=${this.dateTo}`
      }
      if (this.orderBy) {
        url += `&orderBy=${this.orderBy}`
        if (this.orderDesc) {
          url += `&isAscending=${this.orderDesc}`
        }
      }
      if (this.search) {
        url += `&search=${this.search}`
      }

      window.history.pushState(null, '', url)

      try {
        const { data } = await Service.get(`Cashier/Completed${url}`)
        this.orders = data.results
        this.totalItems = data.count
      } catch (error) {}
      this.loading = false
    },
    sortBy (options) {
      this.orderBy = options[0]
    },
    sortDesc (options) {
      this.orderDesc = options[0]
      console.log(options[0])
    },
    handlePageChange (value) {
      this.page = value
      this.getOrders()
    },
    pagination (options) {
      this.page = options.page
      this.itemsPerPage = options.itemsPerPage
    },
    details (item) {
      this.$router.push({ name: 'CashierOrder', params: { id: item.id } })
    }
  }
}
</script>
